<div class="container">
  <div class="row">
    <div class="col-sm-8 col-sm-offset-2 text-dark-blue">
      <div class="col-sm-12">
        <div class="pull-right">
          <app-language-selector></app-language-selector>
        </div>
      </div>
      <app-register></app-register>
    </div>
  </div>
</div>

<app-notifications></app-notifications>
